import { apiCall } from './gqlClient';

const WORKOUTCIRCUITS_QUERY = `
  query workoutCircuits($workoutId: String!) {
    workoutCircuits(workoutId: $workoutId)
    {
      id
			workoutId
			circuitId
			orderIndex
			isOptional
      ...fragments
    }
  }`;

export const workoutCircuitsApiCall = async ({workoutId}, fragments = null) => apiCall({ query: WORKOUTCIRCUITS_QUERY, variables: {workoutId}, fragments });

const CREATEWORKOUTCIRCUIT_QUERY = `
  mutation createWorkoutCircuit($input: WorkoutCircuitInput!) {
    createWorkoutCircuit(input: $input)
    {
      id
			workoutId
			circuitId
			orderIndex
			isOptional
      ...fragments
    }
  }`;

export const createWorkoutCircuitApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEWORKOUTCIRCUIT_QUERY, variables: {input}, fragments });

const UPDATEWORKOUTCIRCUIT_QUERY = `
  mutation updateWorkoutCircuit($id: String!, $input: WorkoutCircuitInput!) {
    updateWorkoutCircuit(id: $id, input: $input)
    {
      id
			workoutId
			circuitId
			orderIndex
			isOptional
      ...fragments
    }
  }`;

export const updateWorkoutCircuitApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATEWORKOUTCIRCUIT_QUERY, variables: {id, input}, fragments });

const DELETEWORKOUTCIRCUIT_QUERY = `
  mutation deleteWorkoutCircuit($id: String!) {
    deleteWorkoutCircuit(id: $id)
    {
      id
			workoutId
			circuitId
			orderIndex
			isOptional
      ...fragments
    }
  }`;

export const deleteWorkoutCircuitApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEWORKOUTCIRCUIT_QUERY, variables: {id}, fragments });
